export const LAYOUT_CONSTANTS = {
  MOBILE_HEADER_HEIGHT: 60,
  MOBILE_CART_HEIGHT: 80,
  DESKTOP_TOP_NAV_HEIGHT: 56,
  SIDEBAR_Z_INDEX: 1001,
  OVERLAY_Z_INDEX: 1000,
  MOBILE_SIDEBAR_WIDTH: '100%',
  DESKTOP_SIDEBAR_WIDTH: '25%',
  DESKTOP_SIDEBAR_MAX_WIDTH: '425px',
  TRANSITION_DURATION: '0.3s'
} as const;

export const Z_INDEX = {
  OVERLAY: 1000,
  SIDEBAR: 1001,
  MOBILE_HEADER: 1002,
  CART_DRAWER: 1100
} as const;
